export default "__VITE_ASSET__DLrWODrt__"